import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi, identityApiRef } from '@mainstage/core-plugin-api';
import { customAlertApiRef } from '@agilelab/plugin-wb-platform';
import { QUERY_KEY_ACCESS_TOKENS } from '../constants';
import { accessTokenApiRef } from '../plugin';
import { RotateAccessTokenRequest } from '@agilelab/plugin-wb-service-accounts-common';
import { AccessToken, SafeAccessToken } from '@agilelab/plugin-wb-auth-backend';

export const useRotateAccessToken = (options?: { alertOnError?: boolean }) => {
  const queryClient = useQueryClient();
  const alertApi = useApi(customAlertApiRef);
  const identityApi = useApi(identityApiRef);
  const accessTokenApi = useApi(accessTokenApiRef);

  const rotateAccessToken = async (
    token: SafeAccessToken,
  ): Promise<AccessToken> => {
    const identityRef = await identityApi.getBackstageIdentity();
    const userEntityRef = identityRef.userEntityRef;

    const request: RotateAccessTokenRequest = {
      uuid: token.uuid,
      updatedBy: userEntityRef,
    };

    const response = await accessTokenApi.rotateAccessToken(request);
    return response;
  };

  const defaultOnSuccess = () => {
    queryClient.invalidateQueries({
      queryKey: [QUERY_KEY_ACCESS_TOKENS],
    });
  };

  return useMutation<AccessToken, Error, SafeAccessToken>({
    mutationFn: rotateAccessToken,
    onSuccess: defaultOnSuccess,
    onError: (error: Error) => {
      if (options?.alertOnError === false) return;
      alertApi.post({
        severity: 'error',
        message: error.message || 'Failed to rotate access token',
      });
    },
  });
};
